// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "disclaimer__wrp-OOhIw";
var _3 = "disclaimer__icon-uRX_j";
export { _1 as "__esModule", _2 as "disclaimer__wrp", _3 as "disclaimer__icon" }
export default { "__esModule": _1, "disclaimer__wrp": _2, "disclaimer__icon": _3 }
